import { useState, useEffect } from 'react';
import axios from 'axios';
import { getAccessToken, selectedSpaceID } from '../../../utils/contentfulUtil';
import { getEnvironment } from '../../../utils/utils';
const contentful = require('contentful');

export const useCaseBuilderData = (slugValue) => {
	const [contentfulData, setContentfulData] = useState(null);
	const [wines, setWines] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			let fields = {};

			try {
				// Fetch Contentful data
				const client = contentful.createClient({
					space: selectedSpaceID,
					accessToken: getAccessToken(),
					host: 'cdn.contentful.com',
					environment: getEnvironment(),
				});

				const contentfulQuery = {
					content_type: 'caseBuilder',
					'fields.slug': slugValue,
				};

				const response = await client.getEntries(contentfulQuery);
				fields = response.items[0]?.fields || {};
				setContentfulData(fields);
			} catch (error) {
				console.error('Error fetching Contentful data:', error);
			}

			try {
				const recommendations = await axios.get(
					`/api/user/recommendations/list`
				);
				setWines(recommendations?.data?.response?.userItems || []);
			} catch (error) {
				console.error('Error fetching recommendations:', error);
				setError(error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { contentfulData, wines, loading, error };
};
